import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useLink from 'Hooks/useLink';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import { IncomeDetailsTable } from './IncomeDetailsTable';


const IncomeDetailsTableContainer = () => {
  const { householdResource } = useSimpleHousehold();
  const { collection, refreshCollection } = useLink(
    householdResource.relationship(fr.relationships.incomeDetails.name).link('related'),
  );

  return (
    <DataContainer
      component={IncomeDetailsTable}
      loading={!collection}
      componentProps={{
        collection,
        refreshCollection,
      }}
    />
  );
};

export default IncomeDetailsTableContainer;
